import { FaKey, FaThumbsUp, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const counter = [
  {
    id: 1,
    icon: <FaKey />, // Key icon
    title: 'Locks Serviced',
    count: '5000',
  },
  {
    id: 2,
    icon: <FaThumbsUp />, // Thumbs-up icon
    title: 'Satisfied Customers',
    count: '10000',
  },
  {
    id: 3,
    icon: <FaPhone />, // Phone icon
    title: 'Emergency Handled',
    count: '500',
  },
  {
    id: 4,
    icon: <FaMapMarkerAlt />, // Map Marker icon
    title: 'Locations Served',
    count: '50',
  },
];

export default counter;